import React from "react";

const divStyle = {
  minWidth: "100%",
  color: "white",
};

class Default extends React.Component {
  render() {
    return (
      <>
        <div style={divStyle}>
          <h1>Virtual Digital Assistant</h1>
        </div>
      </>
    );
  }
}
export default Default;
